import { render, staticRenderFns } from "./RuleMultipleDeletionDialog.vue?vue&type=template&id=0ea51fd9"
import script from "./RuleMultipleDeletionDialog.vue?vue&type=script&lang=ts"
export * from "./RuleMultipleDeletionDialog.vue?vue&type=script&lang=ts"
import style0 from "./RuleMultipleDeletionDialog.vue?vue&type=style&index=0&id=0ea51fd9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports